import { DataTableService } from 'src/app/shared/data-table/data-table.service';
import { EcmPartsSupersedeComponent } from './ecm-parts-supersede/ecm-parts-supersede.component';
import { EcmPartsAddToolRelationComponent } from './ecm-parts-add-tool-relation/ecm-parts-add-tool-relation.component';
import { EcmPartsPartChangeComponent } from './ecm-parts-part-change/ecm-parts-part-change.component';
import { EcmPartsAddProgramRelationComponent } from './ecm-parts-add-program-relation/ecm-parts-add-program-relation.component';
import { EcmPartsService } from './ecm-parts.service';
import { EcmPartsPartComponent } from './ecm-parts-part/ecm-parts-part.component';
import { ToastrService } from 'ngx-toastr';
import { EcmService } from './../../ecm.service';
import { ColumnDef, PageOptions } from './../../../../../shared/data-table/data-table.interface';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { LazyLoadEvent } from 'primeng/api/lazyloadevent';
import { CgpConfirmationDialogService } from 'src/app/shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { EcmPartsReportsComponent } from './ecm-parts-reports/ecm-parts-reports.component';
import { DataTableValidators } from '../../../../../shared/data-table/validators';
import { TprecmApiService } from 'src/modules/api';
import { forkJoin } from 'rxjs';
import { DataTableComponent } from 'src/app/shared/data-table/data-table.component';
import { finalize, filter } from 'rxjs/operators';
import { Router } from '@angular/router';

const FILTER_MAP = {
   supersedingPartId: 'supersedingPartNumber'
};

interface EcmParts {
   toolId: number;
   toolNo: string;
}
interface EcmPartsData {
   tool: EcmParts;
   readonly: boolean;
}

@Component({
   selector: 'ecm-parts',
   templateUrl: './ecm-parts.component.html',
   styleUrls: ['./ecm-parts.component.scss']
})
export class EcmPartsComponent implements OnInit {

   resourced = false;
   programs: any = [];
   partTypes: any = [];
   tools: any = [];
   readonly = false;
   lrs: any = [{ field: 'L', name: 'L' }, { field: 'R', name: 'R' }, { field: 'S', name: 'S' }];
   dA: any = [{ field: 'D', name: 'Detail' }, { field: 'A', name: 'Assembly' }];

   showMode = 'all';

   parts: any[] = [];
   relatedPrograms: any[] = [];
   relatedTools: any[] = [];
   partChanges: any[] = [];
   partNumber: string;

   selectedPart: any;
   selectedPartChange: any;

   totalParts = 0;
   totalPartPrograms = 0;
   totalToolPrograms = 0;
   totalPartChanges = 0;

   tool: EcmParts;
   programId: number;
   partId: number;
   toolId: number;

   searchBarInput: any;
   isPartSelected = false;

   hasLoaded = false;
   loading = false;

   @ViewChild('partsGrid') partsGrid: DataTableComponent;
   @ViewChild('partChangeGrid') partChangeGrid: DataTableComponent;

   defaultPageOptions: PageOptions = this.dataTableService.pageOptionsDefault();

   filters: any;

   partColumnsPageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('partId');
   relatedProgramsPageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('programName');
   relatedToolsPageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('toolNo');
   partChangesPageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('partChangeId');

   partColumns: ColumnDef[] = [
      { field: 'partNumber', name: 'Lead Part#', validators: DataTableValidators.maxLength(8), width: '6em' },
      {
         field: 'partType', name: 'File Type', type: 'dropdown', optionsListField: 'partType', optionsList: this.partTypes,
         optionsListName: 'partType', width: '8em', placeHolderField: 'partType', filterField: false
      },
      { field: 'partName', name: 'Part Name', validators: DataTableValidators.maxLength(200), width: '22em', filterField: false },
      { field: 'supersedingPartNumber', name: 'Superseded By', editable: false, width: '6em' },
      { field: 'oppositePart', name: 'Opp Part #', validators: DataTableValidators.maxLength(8), width: '6em', tooltip: 'Opposite Part Number' },
      { field: 'rL', name: 'L, R, S', type: 'dropdown', optionsList: this.lrs, optionsListField: 'field', optionsListName: 'name', width: '4em', placeHolderField: 'rL', filterField: false },
      { field: 'lhStablePartCode', name: 'LH CSPC', validators: DataTableValidators.maxLength(50), width: '5em', tooltip: 'Left Hand Common Stable Part Code', filterField: false },
      { field: 'rhStablePartCode', name: 'RH CSPC', validators: DataTableValidators.maxLength(50), width: '5em', tooltip: 'Right Hand Common Stable Part Code', filterField: false },
      { field: 'dA', name: 'Detail/Assembly', type: 'dropdown', optionsList: this.dA, optionsListField: 'field', optionsListName: 'name', width: '6em', placeHolderField: 'dA', filterField: false },
      { field: 'notes', name: 'Notes', validators: DataTableValidators.maxLength(2000), width: '25em', filterField: false },
   ];

   relatedProgramsColumns: ColumnDef[] = [
      { field: 'programModelYear', name: 'Program', width: '70%', editable: false, headerHighlight: false },
      {
         field: 'delete', name: 'Delete', type: 'icon-button', width: '30%', sortingDisabled: true, icon: 'delete',
         callback: this.deleteRelatedProgram.bind(this), tooltip: 'Click this button to delete Program from Part relationship.'
      }];

   relatedToolsColumns: ColumnDef[] = [
      { field: 'toolNo', name: 'Tool Number', width: '70%', editable: false, headerHighlight: false },
      {
         field: 'delete', name: 'Delete', type: 'icon-button', width: '30%', sortingDisabled: true, icon: 'delete',
         callback: this.deleteRelatedTool.bind(this), tooltip: 'Click this button to delete Tool from Part relationship.'
      }];

   partChangesColumns: ColumnDef[] = [
      { field: 'releaseLevel', name: 'Rel. Lvl', editable: false, width: '3em', validators: DataTableValidators.maxLength(8), tooltip: 'Release Level', sortingDisabled: true },
      { field: 'approvalDate', name: 'Approval Date', editable: false, width: '5.5em', sortingDisabled: true },
      { field: 'authNumber', name: 'Auth. #(alpha)', editable: false, width: '4.5em', validators: DataTableValidators.maxLength(20), tooltip: 'Authority Number (alpha)', sortingDisabled: true },
      { field: 'authNumberN', name: 'Auth. #(numeric)', editable: false, width: '5em', validators: DataTableValidators.maxLength(20), tooltip: 'Authority Number (numeric)', sortingDisabled: true },
      { field: 'authTypeName', name: 'Auth. Type', editable: false, width: '4em', tooltip: 'Authority Type', sortingDisabled: true },
      { field: 'pdi', name: 'PDI', editable: false, width: '3em', validators: DataTableValidators.maxLength(8), tooltip: 'PDI', sortingDisabled: true },
      { field: 'affectsDesignFmt', name: 'Affects Design?', editable: false, width: '4.5em', tooltip: 'Read Only (Use button for update) - Does this change affect Design?', sortingDisabled: true },
      { field: 'affectsGdtFmt', name: 'Affects GD&T?', editable: false, width: '4.5em', tooltip: 'Read Only (Use button for update) - Does this change affect GD&T?', sortingDisabled: true },
      { field: 'gdtFileName', name: 'GD&T File Name', editable: false, width: '4em', validators: DataTableValidators.maxLength(100), tooltip: 'GD&T File Name', sortingDisabled: true },
      { field: 'buildEvent', name: 'Build Event', editable: false, width: '3.5em', validators: DataTableValidators.maxLength(8), tooltip: 'Build Event', sortingDisabled: true },
      { field: 'reqdForNecFmt', name: 'Req\'d for  NEC?', editable: false, width: '3.5em', tooltip: 'Is this change required for the NEC', sortingDisabled: true },
   ];
   partChange: any;
   updatedPartChange: any;
   isPartChangeSelected: boolean;

   constructor(
      private readonly router: Router,
      private readonly dialogRef: MatDialogRef<EcmPartsComponent>,
      @Inject(MAT_DIALOG_DATA) public data: EcmPartsData,
      private readonly ecmService: EcmService,
      private readonly ecmPartsService: EcmPartsService,
      private readonly tprecmApiService: TprecmApiService,
      private readonly toastr: ToastrService,
      private readonly dialog: MatDialog,
      private readonly confirmation: CgpConfirmationDialogService,
      private readonly dataTableService: DataTableService
   ) { }

   ngOnInit() {
      this.partChangesColumns.forEach(val => {
         if (val.field === 'releaseLevel' || val.field === 'approvalDate' || val.field === 'authNumber' || val.field === 'authNumberN'
            || val.field === 'authTypeName' || val.field === 'pdi' || val.field === 'affectsDesignFmt' || val.field === 'affectsGdtFmt'
            || val.field === 'gdtFileName' || val.field === 'buildEvent' || val.field === 'reqdForNecFmt') {
            val.headerHighlight = false;
            val.type = 'readonly';
         }
      });

      this.relatedProgramsColumns.forEach(val => {
         if (val.field === 'programModelYear') {
            val.headerHighlight = false;
            val.type = 'readonly';
         }
      });

      this.relatedToolsColumns.forEach(val => {
         if (val.field === 'toolNo') {
            val.headerHighlight = false;
            val.type = 'readonly';
         }
      });

      this.tool = this.data.tool;
      this.readonly = this.data.readonly;

      if (this.router.url === '/tprecm/ecm/re-source') {
         this.handleResourcedMode();
      }


      // Get all programs for later use
      this.ecmService.getProgramsUsedInEcm()
         .subscribe(data => {
            this.programs = data;
         });

      // Get all part types for column mapping
      this.ecmPartsService.getPartTypes()
         .subscribe(response => {
            this.partTypes = response;
            this.partColumns
               .find((column: ColumnDef) => column.field === 'partType')
               .optionsList = this.partTypes;
         });

      // set default showMode
      this.showMode = this.tool !== null ? 'tool' : 'all';

      // Handle Readonly Mode
      if (this.readonly) {
         this.partColumns.forEach(col => col.editable = false);
         this.partChangesColumns.forEach(col => col.editable = false);
         this.relatedToolsColumns.forEach(col => col.editable = false);
         this.relatedProgramsColumns.forEach(col => col.editable = false);
      }

      this.hasLoaded = true;
   }

   handleResourcedMode() {
      this.resourced = true;

      this.partColumns.forEach(val => {
         if (val.field !== 'supersedingPartNumber') {
            val.editable = false;
            val.headerHighlight = false;
         }
      });

      this.relatedProgramsColumns.forEach(val => {
         val.editable = false;
         val.headerHighlight = false;
      });

      this.relatedToolsColumns.forEach(val => {
         val.editable = false;
         val.headerHighlight = false;
      });

      this.partChangesColumns.forEach(val => {
         val.editable = false;
         val.headerHighlight = false;
         val.type = 'readonly';
      });

      this.partColumns.forEach(val => {
         if (val.field === 'partNumber' || val.field === 'partName' || val.field === 'oppositePart' ||
            val.field === 'lhStablePartCode' || val.field === 'rhStablePartCode' || val.field === 'notes') {
            val.type = 'readonly';
         }
      });

   }

   /**
    * Lazy Loading
    */

   onLazyLoadParts(event: LazyLoadEvent) {

      this.filters = Object.entries(event.filters)
         .reduce((obj, [key, value]) => ({ ...obj, [FILTER_MAP[key] || key]: value.value }), {});

      this.partColumnsPageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.partColumnsPageOptions.size = event.rows;
      this.partColumnsPageOptions.sort = event.sortField;
      this.partColumnsPageOptions.page = event.first / this.partColumnsPageOptions.size;
      this.refreshParts(this.filters);
   }

   onLazyLoadPartPrograms(event: LazyLoadEvent) {
      this.relatedProgramsPageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.relatedProgramsPageOptions.size = event.rows;
      this.relatedProgramsPageOptions.sort = event.sortField;
      this.relatedProgramsPageOptions.page = event.first / this.relatedProgramsPageOptions.size;
      if (this.selectedPart) {
         this.refreshProgramsByPart(this.selectedPart.partId);
      }
   }

   onLazyLoadPartTools(event: LazyLoadEvent) {
      this.relatedToolsPageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.relatedToolsPageOptions.size = event.rows;
      this.relatedToolsPageOptions.sort = event.sortField;
      this.relatedToolsPageOptions.page = event.first / this.relatedToolsPageOptions.size;
      if (this.selectedPart) {
         this.refreshToolsByPart(this.selectedPart.partId);
      }
   }

   onLazyLoadPartChanges(event: LazyLoadEvent) {
      this.partChangesPageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.partChangesPageOptions.size = event.rows;
      this.partChangesPageOptions.sort = event.sortField;
      this.partChangesPageOptions.page = event.first / this.partChangesPageOptions.size;
      if (this.selectedPart) {
         this.refreshPartChangesByPart(this.selectedPart.partId);
      }
   }

   /**
    * Data Table controls
    */

   resetPageOptions() {
      this.partColumnsPageOptions = {
         ...this.defaultPageOptions,
         sort: 'partId',
      };
   }

   changeProgram(event: any) {
      this.programId = event.value.id;
      this.resetPageOptions();
      this.refreshParts(this.filters || {});
   }


   changeTool(event: any) {
      this.tool.toolId = event.value.id;
      this.tool.toolNo = event.value.toolNo;

      this.resetPageOptions();
      this.refreshParts(this.filters || {});
   }

   showByProgram() {
      this.resetPageOptions();
      this.showMode = 'program';
      if (this.programId) {
         this.refreshParts(this.filters || {});
      }
   }

   showByTool() {
      this.resetPageOptions();
      this.refreshParts(this.filters || {}, 'tool');
   }

   showByPart(event: any) {
      this.partNumber = event.value;
      this.resetPageOptions();
      this.refreshParts(this.filters || {});
   }

   showAll() {
      this.resetPageOptions();
      this.refreshParts(this.filters || {}, 'all');
   }

   partChangesFmt(part: any) {
      return {
         ...part,
         affectsGdtFmt: part.affectsGdt === 1 ? 'Yes' : (part.affectsGdt === 0 ? 'No' : ''),
         affectsDesignFmt: part.affectsDesign === 1 ? 'Yes' : (part.affectsDesign === 0 ? 'No' : ''),
         reqdForNecFmt: part.reqdForNec === 1 ? 'Yes' : (part.reqdForNec === 0 ? 'No' : ''),
      };
   }

   refreshAll(partId: number) {
      if (!partId) {
         return;
      }

      forkJoin([
         this.ecmPartsService.getProgramsByPart(partId, this.relatedProgramsPageOptions),
         this.ecmPartsService.getToolsByPart(partId, this.relatedToolsPageOptions),
         this.ecmPartsService.getPartChangesByPart(partId, this.partChangesPageOptions)
      ]).subscribe(([programs, tools, changes]) => {
         this.totalPartPrograms = programs.totalCount;
         this.relatedPrograms = programs.data || [];

         this.totalToolPrograms = tools.totalCount;
         this.relatedTools = tools.data || [];

         this.totalPartChanges = changes.totalCount;
         this.partChanges = (changes.data || [])
            .map((part) => this.partChangesFmt(part));
         if (this.partChanges.length > 0) {
            this.partChangeGrid.selections = this.selectedPartChange;
            this.selectedPartChange = this.partChangeGrid.selections[0];
         }
      });
   }

   refreshProgramsByPart(partId: number) {
      if (!partId) {
         return;
      }

      this.ecmPartsService.getProgramsByPart(partId, this.relatedProgramsPageOptions)
         .subscribe(data => {
            this.totalPartPrograms = data.totalCount;
            this.relatedPrograms = data.data || [];
         });
   }

   refreshToolsByPart(partId: number) {
      if (!partId) {
         return;
      }

      this.ecmPartsService.getToolsByPart(partId, this.relatedToolsPageOptions)
         .subscribe(data => {
            this.totalToolPrograms = data.totalCount;
            this.relatedTools = data.data || [];
         });
   }

   refreshPartChangesByPart(partId: number, partChangeId?: any) {
      if (!partId) {
         return;
      }

      this.ecmPartsService.getPartChangesByPart(partId, this.partChangesPageOptions)
         .subscribe(data => {
            this.totalPartChanges = data.totalCount;
            this.partChanges = (data.data || [])
               .map((part) => this.partChangesFmt(part));
            if (partChangeId) {
               this.partChangeGrid.selections = [this.partChanges.find(el => el.partChangeId === partChangeId)];
               this.selectedPartChange = this.partChangeGrid.selections[0];
            }
            else if (this.selectedPartChange) {
               this.partChangeGrid.selections = [this.partChanges.find(el => el.partChangeId === this.selectedPartChange.partChangeId)];
               this.selectedPartChange = this.partChangeGrid.selections[0];
            }
         });

   }

   refreshParts(filters: any, showMode?: string, part?: any) {
      this.loading = true;
      this.showMode = showMode || this.showMode;
      this.ecmService.getParts(
         this.showMode === 'tool' || (this.showMode === 'program' && !this.programId) ? this.tool.toolId : undefined,
         this.showMode === 'program' ? this.programId : undefined,
         this.partNumber,
         this.partColumnsPageOptions,
         filters
      ).pipe(
         filter(Boolean),
         finalize(() => this.loading = false)).subscribe((data: { totalCount: number, data: any[] }) => {
            this.parts = data.data || [];
            this.totalParts = data.totalCount;
            this.isPartSelected = this.totalParts ? true : false;
            this.isPartChangeSelected = this.selectedPartChange ? true : false;
            if (part) {
               this.selectedPart = this.parts.find(el => el.partNumber === part.partNumber);
               this.partId = this.selectedPart.partId;
               this.partsGrid.selections = [this.selectedPart];
               this.refreshAll(part.partId);
            }
            else if (this.parts.length > 0) {
               this.selectedPart = this.parts[0];
               this.partId = this.selectedPart.partId;
               this.partsGrid.selections = [this.parts[0]];
               this.refreshAll(this.parts[0].partId);
            } else {
               this.relatedPrograms = [];
               this.relatedTools = [];
               this.partChanges = [];

               this.totalPartPrograms = 0;
               this.totalToolPrograms = 0;
               this.totalPartChanges = 0;
            }
         });
   }

   /**
    * Data Table Row Editing
    */
   partRowEdited(event: any) {
      const body = event.data;
      body.partNumber = body.partNumber.toUpperCase();
      body.partName = body.partName.toUpperCase();
      if (body.oppositePart != null) {
         body.oppositePart = body.oppositePart.toUpperCase();
      }
      if (body.lhStablePartCode !== null) {
         body.lhStablePartCode = body.lhStablePartCode.trim().length === 0 ? null : body.lhStablePartCode.toUpperCase();
      }
      if (body.rhStablePartCode != null) {
         body.rhStablePartCode = body.rhStablePartCode.trim().length === 0 ? null : body.rhStablePartCode.toUpperCase();
      }

      // Convert detail/assembly to short version if stored as long
      const longDa = this.dA.find(val => val.name === body.dA);
      body.dA = longDa ? longDa.field : body.dA;


      // Convert PartTypes to their ID's
      body.partTypeId = this.partTypes
         .find(partType => partType.partType === body.partType)
         .partTypeId;

      this.ecmPartsService.modifyPart(body)
         .pipe(finalize(() => this.refreshParts(this.filters)))
         .subscribe();
   }

   deleteRelatedProgram(data: any) {
      if (this.relatedPrograms.length <= 1) {
         this.toastr.error('Cannot remove last related program for a part.');
         return;
      }

      const dialogRef = this.confirmation.showConfirmationDialog({
         title: 'Confirm Deletion',
         message: `Are you sure you want to delete the program relation: ${data.programModelYear}`,
         onYesClick: () => {
            this.ecmPartsService.deleteProgramPartRelation(data.partProgramId, data.partId)
               .subscribe({
                  error: () => this.toastr.error(`Failed to delete part-program relation: ${data.partId} - ${data.programModelYear}`),
                  complete: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
               });
         },
         onNoClick: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
      });

      dialogRef.afterClosed()
         .subscribe(this.refreshProgramsByPart.bind(this, data.partId));
   }

   deleteRelatedTool(data: any) {
      // Checkbox sets value after this function, so must update immediatly after
      setTimeout(() => (data || {}).delete = false);

      const dialogRef = this.confirmation.showConfirmationDialog({
         title: 'Confirm Deletion',
         message: `Are you sure you want to delete the Tool relationship to Part row?`,
         onYesClick: () => {
            this.ecmPartsService.deleteToolPartRelation(data.partId, data.partToToolId)
               .subscribe({
                  error: () => this.toastr.error(`Failed to delete part-tool relation!`),
                  complete: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
               });
         },
         onNoClick: this.confirmation.closeConfirmationDialog.bind(this.confirmation)
      });

      dialogRef.afterClosed()
         .subscribe(() => {
            this.refreshToolsByPart(data.partId);
            this.refreshParts(this.filters || {}, null, this.selectedPart);
         });
   }

   /**
    * Data Table Row Selection Callbacks
    */
   partSelected(selected: any) {
      if (!(selected && selected.partId)) {
         return;
      }

      this.selectedPart = selected;
      this.partId = null;
      this.totalPartPrograms = 0;
      this.totalToolPrograms = 0;
      this.totalPartChanges = 0;
      this.relatedPrograms = [];
      this.relatedTools = [];
      this.partChanges = [];
      this.selectedPartChange = null;

      if (selected) {
         this.partId = selected.partId;
         this.refreshAll(selected.partId);
      }

   }

   partChangeSelected(selected: any) {
      this.selectedPartChange = selected;
      this.isPartChangeSelected = this.selectedPartChange ? true : false;
   }

   /**
    * Parts Data Table Buttons
    */

   addPart() {
      const dialogRef = this.dialog.open(EcmPartsPartComponent, {
         disableClose: true,
         data: this.parts,
         height: '50vh',
         width: '20vw'
      });

      dialogRef.afterClosed()
         .subscribe((part: any) => {
            if (part) {
               this.parts.unshift(part);
               this.selectedPart = part;
               this.partsGrid.selections = [part];
               this.isPartSelected = true;
               this.refreshAll(this.selectedPart.partId);
            } else {
               this.refreshParts(this.filters);
            }
         });
   }

   deletePart() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to be deleted.');
         return;
      }

      const dialogRef = this.confirmation.showConfirmationDialog({
         title: 'Confirm',
         message: `Are you sure you want to delete the part: ${this.selectedPart.partName}`,
         onYesClick: () => {
            this.ecmPartsService.deletePart(this.selectedPart.partId)
               .pipe(finalize(() => this.refreshParts(this.filters)))
               .subscribe();

            this.confirmation.closeConfirmationDialog();
         },
         onNoClick: () => {
            this.confirmation.closeConfirmationDialog();
         }
      });

      dialogRef.afterClosed()
         .subscribe(() => this.refreshParts(this.filters));
   }

   modifyPart() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to be modified');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsPartComponent, {
         disableClose: true,
         data: this.selectedPart,
      });

      dialogRef.afterClosed()
         .subscribe(() => this.refreshParts(this.filters));
   }

   showReports() {
      this.dialog.open(EcmPartsReportsComponent, {
         disableClose: true,
         autoFocus: true,
         height: '64vh',
         width: '54vw',
      });
   }

   supersedePart() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to be modified');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsSupersedeComponent, {
         disableClose: true,
         data: this.selectedPart,
      });

      dialogRef.afterClosed()
         .subscribe((val: any) => this.refreshParts(this.filters, null, val));
   }

   deleteSupersedPart() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to delete it supersed part.');
         return;
      }

      const dialogRef = this.confirmation.showConfirmationDialog({
         title: 'Confirm',
         width: '480px',
         message: `Removing a part supersession will orphan another part record
        and may leave erroneous links to tool records and supersession
        notes in another part number. Would you like to continue?`,
         onYesClick: () =>
            this.ecmPartsService.deleteSupersedePart(this.selectedPart.partId)
               .subscribe({
                  error: () => this.toastr.error(`Failed to delete part supersed for: ${this.selectedPart.partName}`),
                  complete: () => {
                     this.confirmation.closeConfirmationDialog();
                     this.refreshParts(this.filters, null, this.selectedPart);
                  }
               }),
         onNoClick: () => {
            this.confirmation.closeConfirmationDialog();
         }
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.refreshParts(this.filters));
   }

   /**
    * Part Change Data Table buttons
    */

   addPartChange() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to add a part change too.');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsPartChangeComponent, {
         disableClose: true,
         data: {
            partId: this.selectedPart.partId,
            toolTypeList: this.selectedPart.toolTypeList,
         },
      });

      dialogRef.afterClosed()
         .subscribe(() => this.refreshPartChanges());
   }

   refreshPartChanges() {
      this.partChangesPageOptions.sort = 'partChangeId';
      this.partChangesPageOptions.order = 'desc';
      this.refreshPartChangesByPart(this.selectedPart.partId);
   }

   modifyPartChange() {
      if (!(this.selectedPartChange && this.selectedPartChange.partChangeId)) {
         this.toastr.error('Please select a part change to modify.');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsPartChangeComponent, {
         disableClose: true,
         data: {
            ...this.selectedPartChange,
            toolId: this.tool.toolId,
            toolTypeList: this.selectedPart.toolTypeList
         },
      });

      dialogRef.afterClosed()
         .subscribe((data: any) => {
            this.refreshPartChangesByPart(this.selectedPart.partId, data);
         });
   }

   deletePartChange() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part to delete part changes for.');
         return;
      }

      if (!(this.selectedPartChange && this.selectedPartChange.partChangeId)) {
         this.toastr.error('Please select a part change to be deleted.');
         return;
      }

      else {
         const dialogRef = this.confirmation.showConfirmationDialog({
            title: 'Confirm',
            message: `Are you sure you want to delete the selected part change?`,
            onYesClick: () =>
               this.ecmPartsService.deletePartChange(this.selectedPart.partId, this.selectedPartChange.partChangeId)
                  .pipe(finalize(() => this.confirmation.closeConfirmationDialog()))
                  .subscribe(),
            onNoClick: () => {
               this.confirmation.closeConfirmationDialog();
               this.partChangeGrid.selections = [this.partChanges.find(el => el.partChangeId === this.selectedPartChange.partChangeId)];
               this.selectedPartChange = this.partChangeGrid.selections[0];
            }
         });

         dialogRef.afterClosed()
            .subscribe(this.refreshPartChangesByPart.bind(this, this.selectedPart.partId));
      }

   }

   /**
    * Program Part Relation Data Table Buttons
    */

   addProgramPartRelation() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part before adding a program');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsAddProgramRelationComponent, {
         disableClose: true,
         data: {
            part: this.selectedPart,
            relations: this.relatedPrograms.map(program => program.programId)
         },
      });

      dialogRef.afterClosed()
         .subscribe(() => this.refreshPartPrograms());
   }

   refreshPartPrograms() {
      this.relatedProgramsPageOptions.sort = 'partProgramId';
      this.relatedProgramsPageOptions.order = 'desc';
      this.refreshProgramsByPart(this.selectedPart.partId);
   }

   /**
    * Tool Part Relation Data Table buttons
    */
   addToolPartRelation() {
      if (!(this.selectedPart && this.selectedPart.partId)) {
         this.toastr.error('Please select a part before adding a program');
         return;
      }

      const dialogRef = this.dialog.open(EcmPartsAddToolRelationComponent, {
         disableClose: true,
         data: {
            partId: this.selectedPart.partId,
            relations: this.relatedTools.map(tool => tool.toolId)
         },
      });

      dialogRef.afterClosed()
         .subscribe(() => {
            this.refreshPartTools();
            this.refreshParts(this.filters || {}, null, this.selectedPart);
         });
   }

   refreshPartTools() {
      this.relatedToolsPageOptions.sort = 'partToToolId';
      this.relatedToolsPageOptions.order = 'desc';
      this.refreshToolsByPart(this.selectedPart.partId);
   }

   clearSearch() {
      this.searchBarInput = '';
      this.partNumber = '';
      this.refreshParts(this.filters || {});
   }

   /**
    * Dialog Controls
    */

   close() {
      this.dialogRef.close(this.tool);
   }

   /**
    * Utility Functions
    */
   private getParam(obj: any, id: string): any | undefined {
      return obj ? obj[id] : undefined;
   }

   get selectionCriteria(): { [field: string]: any } {
      const selections = JSON.parse(sessionStorage.getItem('selections')) || { areas: [] };
      const programIds = selections.programs.map((p: any) => p.id);

      return {
         programIds: programIds.length > 0 ? programIds : undefined,
         chkBiw: selections.areas.includes('BIW'),
         chkDei: selections.areas.includes('DEI'),
         chkGae: selections.areas.includes('GAE'),
         engineerId: this.getParam(selections.engineer, 'id'),
         partNumber: this.getParam(selections.partNoLH, 'partNumber'),
         stablePartCode1: this.getParam(selections.cspcLH, 'stablePartCode1'),
         toolNo: this.getParam(selections.gageNo, 'toolNo'),
         cfe: this.getParam(selections.constEngineer, 'cfe'),
         dsRep: this.getParam(selections.designSourceRep, 'dsRep'),
         partNumber2: this.getParam(selections.partNoRH, 'partNumber2'),
         stablePartCode2: this.getParam(selections.cspcRH, 'stablePartCode2'),
         typeId: this.getParam(selections.fixtureType, 'id'),
         firstUserSourceId: this.getParam(selections.firstUserSource, 'id'),
         designSourceId: this.getParam(selections.designSource, 'id'),
         userSourceId: this.getParam(selections.userSource, 'id'),
         constSourceId: this.getParam(selections.buildSource, 'id'),
         toolName: selections.keyword || undefined,
         reSourced: 0
      };
   }
}
